module.exports = __webpack_public_path__ + "img/about-office-img-2.1001ad4d.jpg";